import Service from '../../service'

const state = {
    paymentList: []
}
const actions = {
    onGetPaymentList({ commit }, params = {}) {
        return Service.payment.getPaymentList(params).then(res => {
            // something
            return res.data
        })
    },
    onGetPaymentDetail({ commit }, params = {}) {
        return Service.payment.getPaymentDetail(params).then(res => {
            // something
            //commit('setPaymentList', res.data)
            return res.data
        })
    }
}
const mutations = {
    setPaymentList(state, data) {
        state.paymentList = data
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}